export default {
  'de-DE': 'German',
  'en-GB': 'English (UK)',
  'en-US': 'English (US)',
  'en-IN': 'English (Indian)',
  'en-AU': 'English (Australian)',
  'es-ES': 'Spanish',
  'es-US': 'Spanish (US)',
  'da-DK': 'Danish',
  'fi-FI': 'Finnish',
  'fr-FR': 'French',
  'fr-BE': 'French (Belgium)',
  'hi-IN': 'Hindi',
  'hu-HU': 'Hungarian',
  'id-ID': 'Indonesian',
  'in-ID': 'Indonesian',
  'it-IT': 'Italian',
  'ja-JP': 'Japanese',
  'ko-KR': 'Korean',
  'nl-NL': 'Dutch (Netherlands)',
  'pl-PL': 'Polish',
  'pt-PT': 'Portuguese',
  'pt-BR': 'Portuguese (Brazil)',
  'ru-RU': 'Russian',
  'zh-CN': 'Chinese',
  'zh-HK': 'Chinese (Hong Kong)',
  'zh-TW': 'Chinese (Taiwan)',
  'sv-SE': 'Swedish',
  'tr-TR': 'Turkish',
  'vi-VN': 'Vietnamese',
  'nb-NO': 'Norwegian',
  'th-TH': 'Thai',


};



// WEBPACK FOOTER //
// ./src/modules/languagenames.js